<template>
    <div>
        <div v-if="createdDevicesByDays" class="card dashboardWidget ">
            <div class="card-header">
                <h2>Device History</h2>
            </div>
            <div class="card-body">

                <dx-chart id="chart"
                          :data-source="dataSource"
                          :size="size"
                         
                          >
                    <dx-common-series-settings :type="type"
                                               argument-field="country"
                                               :line="line"
                                               :point="point" />
                    <dx-value-axis :value-margins-enabled="true"
                                   min="0"
                                   :tick="tick"
                                   :minorTick="minorTick"
                                   :minorTickInterval="minorTickInterval"
                                   :tick-interval="10"
                                   name="amount"
                                   position="left" />
                    <dx-value-axis :show-zero="true"
                                   :value-margins-enabled="false"
                                   min="0"
                                   max="100"
                                   :minorTickInterval="minorTickInterval"
                                   :minorTick="minorTick"
                                    :tick-interval="10"
                                   position="right" />
                    <dx-series name="Devices Created"
                               argument-field="date"
                               value-field="amount"
                               visibility="false"
                               hover-mode="includePoints"
                               :tickInterval="tickInterval"
                               :minorTickInterval="minorTickInterval"
                               :minorTick="minorTick"
                               type="line"
                               axis="amount"
                               color="#7fbf1a" />
                    <!--<dx-series name="Cumulative Percentage"
                               argument-field="date"
                               value-field="cumulativePercentage"
                               axis="percentage"
                               type="line"
                               color="#00abd5" />-->

                    <dx-argument-axis :value-margins-enabled="false"
                                      :label="label"
                                      discrete-axis-division-mode="crossLabels">
                        <dx-grid :visible="true" />
                    </dx-argument-axis>
                    <dx-legend vertical-alignment="bottom"
                               horizontal-alignment="center"
                               item-text-position="bottom"
                               hover-mode="includePoints" />
                    <dx-tooltip :enabled="true" />

                </dx-chart>
            </div>
        </div>
        <LoadingAnimation v-else></LoadingAnimation>
    </div>
</template>
<script>
    import LoadingAnimation from '@/components/general/LoadingAnimation.vue'
    import {
        DxChart,
        DxSeries,
        DxArgumentAxis,
        DxCommonSeriesSettings,
        DxExport,
        DxGrid,
        DxMargin,
        DxLegend,
        DxTitle,
        DxSubtitle,
        DxTooltip,
        DxValueAxis,
        DxSelectBox
    } from 'devextreme-vue/chart';

    export default {
        props: {
            createdDevicesByDays: {
                type: Array,
                default: () => { }
            }
        },
        components: {
            DxChart,
            DxSeries,
            DxArgumentAxis,
            DxCommonSeriesSettings,
            DxExport,
            DxGrid,
            DxMargin,
            DxLegend,
            DxTitle,
            DxSubtitle,
            DxTooltip,
            DxValueAxis,
            LoadingAnimation,
            DxSelectBox
        },
        data: function () {
            return {
                size: { height: 200, width: 'auto' },
                type: 'line',
                point: { visible: false },
                line: { width: 2 },
                tick: { visible: true },
                tickInterval: 5,
                minorTick: { visible: true, color: 'green', name: "days" },
                minorTickInterval: 10,
                label: { overlappingBehavior: "stagger" },
                zoomAndPan: {
                    argumentAxis: "both",
                },
              
            }
        },
        computed: {
            dataSource() {
                let data = this.createdDevicesByDays,
                    totalCount = data.reduce(function (prevValue, item) {
                        return prevValue + item.amount;
                    }, 0),
                    cumulativeCount = 0;
                return data.map(function (item) {
                    cumulativeCount += item.amount;
                    return {
                        date: item.date,
                        amount: item.amount,
                        cumulativePercentage: Math.round(cumulativeCount * 100 / totalCount)
                    };
                });
            },
            reverse() {
                return this.createdDevicesByDays.reverse();
            }
        },
        methods: {
            customizeTooltip: (arg) => {
                return {
                    text: arg.valueText
                };
            },
        },
        created() {

        },
    }
</script>

<style scoped>

    .container-fluid {
        width: auto;
        height: auto
    }
</style>